import { initialState } from 'root/stores/notifications/schema';

export const reduceDeleteNotificationMessage = (state) => ({
  ...state,
  notification: initialState.notification,
});
